<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre11" id="pgepubid00005">EMMA GOLDMAN
</h3>
<p class="intro">
     Propagandism is not, as some suppose, a "trade," because
     nobody will follow a "trade" at which you may work with
     the industry of a slave and die with the reputation of a
     mendicant.  The motives of any persons to pursue such a
     profession must be different from those of trade, deeper
     than pride, and stronger than interest.<br class="calibre5"/><br class="calibre5"/>
                                       GEORGE JACOB HOLYOAKE.
</p>
<p class="calibre12">
Among the men and women prominent in the public life of America there
are but few whose names are mentioned as often as that of Emma
Goldman.  Yet the real Emma Goldman is almost quite unknown.  The
sensational press has surrounded her name with so much
misrepresentation and slander, it would seem almost a miracle that,
in spite of this web of calumny, the truth breaks through and a
better appreciation of this much maligned idealist begins to manifest
itself.  There is but little consolation in the fact that almost
every representative of a new idea has had to struggle and suffer
under similar difficulties.  Is it of any avail that a former
president of a republic pays homage at Osawatomie to the memory of
John Brown?  Or that the president of another republic participates
in the unveiling of a statue in honor of Pierre Proudhon, and holds
up his life to the French nation as a model worthy of enthusiastic
emulation?  Of what avail is all this when, at the same time, the
LIVING John Browns and Proudhons are being crucified?  The honor and
glory of a Mary Wollstonecraft or of a Louise Michel are not enhanced
by the City Fathers of London or Paris naming a street after
them—the living generation should be concerned with doing justice to
the LIVING Mary Wollstonecrafts and Louise Michels.  Posterity
assigns to men like Wendel Phillips and Lloyd Garrison the proper
niche of honor in the temple of human emancipation; but it is the
duty of their contemporaries to bring them due recognition and
appreciation while they live.
</p>
<p class="calibre12">
The path of the propagandist of social justice is strewn with thorns.
The powers of darkness and injustice exert all their might lest a ray
of sunshine enter his cheerless life.  Nay, even his comrades in the
struggle—indeed, too often his most intimate friends—show but
little understanding for the personality of the pioneer.  Envy,
sometimes growing to hatred, vanity and jealousy, obstruct his way
and fill his heart with sadness.  It requires an inflexible will and
tremendous enthusiasm not to lose, under such conditions, all faith
in the Cause.  The representative of a revolutionizing idea stands
between two fires: on the one hand, the persecution of the existing
powers which hold him responsible for all acts resulting from social
conditions; and, on the other, the lack of understanding on the part
of his own followers who often judge all his activity from a narrow
standpoint.  Thus it happens that the agitator stands quite alone in
the midst of the multitude surrounding him.  Even his most intimate
friends rarely understand how solitary and deserted he feels.  That
is the tragedy of the person prominent in the public eye.
</p>
<p class="calibre12">
The mist in which the name of Emma Goldman has so long been enveloped
is gradually beginning to dissipate.  Her energy in the furtherance
of such an unpopular idea as Anarchism, her deep earnestness, her
courage and abilities, find growing understanding and admiration.
</p>
<p class="calibre12">
The debt American intellectual growth owes to the revolutionary
exiles has never been fully appreciated.  The seed disseminated by
them, though so little understood at the time, has brought a rich
harvest.  They have at all times held aloft the banner of liberty,
thus impregnating the social vitality of the Nation.  But very few
have succeeding in preserving their European education and culture
while at the same time assimilating themselves with American life.
It is difficult for the average man to form an adequate conception
what strength, energy, and perseverance are necessary to absorb the
unfamiliar language, habits, and customs of a new country, without
the loss of one's own personality.
</p>
<p class="calibre12">
Emma Goldman is one of the few who, while thoroughly preserving their
individuality, have become an important factor in the social and
intellectual atmosphere of America.  The life she leads is rich in
color, full of change and variety.  She has risen to the topmost
heights, and she has also tasted the bitter dregs of life.
</p>
<p class="calibre12">
Emma Goldman was born of Jewish parentage on the 27th day of June,
1869, in the Russian province of Kovno.  Surely these parents never
dreamed what unique position their child would some day occupy.  Like
all conservative parents they, too, were quite convinced that their
daughter would marry a respectable citizen, bear him children, and
round out her allotted years surrounded by a flock of grandchildren,
a good, religious woman.  As most parents, they had no inkling what a
strange, impassioned spirit would take hold of the soul of their
child, and carry it to the heights which separate generations in
eternal struggle.  They lived in a land and at a time when antagonism
between parent and offspring was fated to find its most acute
expression, irreconcilable hostility.  In this tremendous struggle
between fathers and sons—and especially between parents and
daughters—there was no compromise, no weak yielding, no truce.  The
spirit of liberty, of progress—an idealism which knew no
considerations and recognized no obstacles—drove the young
generation out of the parental house and away from the hearth of the
home.  Just as this same spirit once drove out the revolutionary
breeder of discontent, Jesus, and alienated him from his native
traditions.
</p>
<p class="calibre12">
What role the Jewish race—notwithstanding all anti-semitic calumnies
the race of transcendental idealism—played in the struggle of the
Old and the New will probably never be appreciated with complete
impartiality and clarity.  Only now are we beginning to perceive the
tremendous debt we owe to Jewish idealists in the realm of science,
art, and literature.  But very little is still known of the important
part the sons and daughters of Israel have played in the
revolutionary movement and, especially, in that of modern times.
</p>
<p class="calibre12">
The first years of her childhood Emma Goldman passed in a small,
idyllic place in the German-Russian province of Kurland, where her
father had charge of the government stage.  At the time Kurland was
thoroughly German; even the Russian bureaucracy of that Baltic
province was recruited mostly from German JUNKERS.  German fairy
tales and stories, rich in the miraculous deeds of the heroic knights
of Kurland, wove their spell over the youthful mind.  But the
beautiful idyl was of short duration.  Soon the soul of the growing
child was overcast by the dark shadows of life.  Already in her
tenderest youth the seeds of rebellion and unrelenting hatred of
oppression were to be planted in the heart of Emma Goldman.  Early
she learned to know the beauty of the State: she saw her father
harassed by the Christian CHINOVNIKS and doubly persecuted as petty
official and hated Jew.  The brutality of forced conscription ever
stood before her eyes: she beheld the young men, often the sole
supporter of a large family, brutally dragged to the barracks to lead
the miserable life of a soldier.  She heard the weeping of the poor
peasant women, and witnessed the shameful scenes of official venality
which relieved the rich from military service at the expense of the
poor.  She was outraged by the terrible treatment to which the female
servants were subjected: maltreated and exploited by their BARINYAS,
they fell to the tender mercies of the regimental officers, who
regarded them as their natural sexual prey.  The girls, made pregnant
by respectable gentlemen and driven out by their mistresses, often
found refuge in the Goldman home.  And the little girl, her heart
palpitating with sympathy, would abstract coins from the parental
drawer to clandestinely press the money into the hands of the
unfortunate women.  Thus Emma Goldman's most striking characteristic,
her sympathy with the underdog, already became manifest in these
early years.
</p>
<p class="calibre12">
At the age of seven little Emma was sent by her parents to her
grandmother at Konigsberg, the city of Emanuel Kant, in Eastern
Prussia.  Save for occasional interruptions, she remained there till her
13th birthday.  The first years in these surroundings do not exactly
belong to her happiest recollections.  The grandmother, indeed, was
very amiable, but the numerous aunts of the household were concerned
more with the spirit of practical rather than pure reason, and the
categoric imperative was applied all too frequently.  The situation
was changed when her parents migrated to Konigsberg, and little Emma
was relieved from her role of Cinderella.  She now regularly attended
public school and also enjoyed the advantages of private instruction,
customary in middle class life; French and music lessons played an
important part in the curriculum.  The future interpreter of Ibsen
and Shaw was then a little German Gretchen, quite at home in the
German atmosphere.  Her special predilections in literature were the
sentimental romances of Marlitt; she was a great admirer of the good
Queen Louise, whom the bad Napoleon Buonaparte treated with so marked
a lack of knightly chivalry.  What might have been her future
development had she remained in this milieu?  Fate—or was it
economic necessity?—willed it otherwise.  Her parents decided to
settle in St. Petersburg, the capital of the Almighty Tsar, and there
to embark in business.  It was here that a great change took place in
the life of the young dreamer.
</p>
<p class="calibre12">
It was an eventful period—the year of 1882—in which Emma Goldman,
then in her 13th year, arrived in St. Petersburg.  A struggle for
life and death between the autocracy and the Russian intellectuals
swept the country.  Alexander II had fallen the previous year.
Sophia Perovskaia, Zheliabov, Grinevitzky, Rissakov, Kibalchitch,
Michailov, the heroic executors of the death sentence upon the
tyrant, had then entered the Walhalla of immortality.  Jessie
Helfman, the only regicide whose life the government had reluctantly
spared because of pregnancy, followed the unnumbered Russian martyrs
to the etapes of Siberia.  It was the most heroic period in the great
battle of emancipation, a battle for freedom such as the world had
never witnessed before.  The names of the Nihilist martyrs were on
all lips, and thousands were enthusiastic to follow their example.
The whole INTELLIGENZIA of Russia was filled with the ILLEGAL
spirit: revolutionary sentiments penetrated into every home, from
mansion to hovel, impregnating the military, the CHINOVNIKS, factory
workers, and peasants.  The atmosphere pierced the very casemates of
the royal palace.  New ideas germinated in the youth.  The difference
of sex was forgotten.  Shoulder to shoulder fought the men and the
women.  The Russian woman!  Who shall ever do justice or adequately
portray her heroism and self-sacrifice, her loyalty and devotion?
Holy, Turgeniev calls her in his great prose poem, ON THE THRESHOLD.
</p>
<p class="calibre12">
It was inevitable that the young dreamer from Konigsberg should be
drawn into the maelstrom.  To remain outside of the circle of free
ideas meant a life of vegetation, of death.  One need not wonder at
the youthful age.  Young enthusiasts were not then—and, fortunately,
are not now—a rare phenomenon in Russia.  The study of the Russian
language soon brought young Emma Goldman in touch with revolutionary
students and new ideas.  The place of Marlitt was taken by Nekrassov
and Tchernishevsky.  The quondam admirer of the good Queen Louise
became a glowing enthusiast of liberty, resolving, like thousands of
others, to devote her life to the emancipation of the people.
</p>
<p class="calibre12">
The struggle of generations now took place in the Goldman family.
The parents could not comprehend what interest their daughter could
find in the new ideas, which they themselves considered fantastic
utopias.  They strove to persuade the young girl out of these
chimeras, and daily repetition of soul-racking disputes was the
result.  Only in one member of the family did the young idealist find
understanding—in her elder sister, Helene, with whom she later
emigrated to America, and whose love and sympathy have never failed
her.  Even in the darkest hours of later persecution Emma Goldman
always found a haven of refuge in the home of this loyal sister.
</p>
<p class="calibre12">
Emma Goldman finally resolved to achieve her independence.  She saw
hundreds of men and women sacrificing brilliant careers to go V
NAROD, to the people.  She followed their example.  She became a
factory worker; at first employed as a corset maker, and later in the
manufacture of gloves.  She was now 17 years of age and proud to earn
her own living.  Had she remained in Russia, she would have probably
sooner or later shared the fate of thousands buried in the snows of
Siberia.  But a new chapter of life was to begin for her.  Sister
Helene decided to emigrate to America, where another sister had
already made her home.  Emma prevailed upon Helene to be allowed to
join her, and together they departed for America, filled with the
joyous hope of a great, free land, the glorious Republic.
</p>
<p class="calibre12">
America!  What magic word.  The yearning of the enslaved, the
promised land of the oppressed, the goal of all longing for progress.
Here man's ideals had found their fulfillment: no Tsar, no Cossack,
no CHINOVNIK.  The Republic!  Glorious synonym of equality, freedom,
brotherhood.
</p>
<p class="calibre12">
Thus thought the two girls as they travelled, in the year 1886, from
New York to Rochester.  Soon, all too soon, disillusionment awaited
them.  The ideal conception of America was punctured already at
Castle Garden, and soon burst like a soap bubble.  Here Emma Goldman
witnessed sights which reminded her of the terrible scenes of her
childhood in Kurland.  The brutality and humiliation the future
citizens of the great Republic were subjected to on board ship, were
repeated at Castle Garden by the officials of the democracy in a more
savage and aggravating manner.  And what bitter disappointment
followed as the young idealist began to familiarize herself with the
conditions in the new land!  Instead of one Tsar, she found scores of
them; the Cossack was replaced by the policeman with the heavy club,
and instead of the Russian CHINOVNIK there was the far more inhuman
slave-driver of the factory.
</p>
<p class="calibre12">
Emma Goldman soon obtained work in the clothing establishment of the
Garson Co.  The wages amounted to two and a half dollars a week.  At
that time the factories were not provided with motor power, and the
poor sewing girls had to drive the wheels by foot, from early morning
till late at night.  A terribly exhausting toil it was, without a ray
of light, the drudgery of the long day passed in complete
silence—the Russian custom of friendly conversation at work was not
permissible in the free country.  But the exploitation of the girls
was not only economic; the poor wage workers were looked upon by
their foremen and bosses as sexual commodities.  If a girl resented
the advances of her "superiors", she would speedily find herself on
the street as an undesirable element in the factory.  There was never
a lack of willing victims: the supply always exceeded the demand.
</p>
<p class="calibre12">
The horrible conditions were made still more unbearable by the
fearful dreariness of life in the small American city.  The Puritan
spirit suppresses the slightest manifestation of joy; a deadly
dullness beclouds the soul; no intellectual inspiration, no thought
exchange between congenial spirits is possible.  Emma Goldman almost
suffocated in this atmosphere.  She, above all others, longed for
ideal surroundings, for friendship and understanding, for the
companionship of kindred minds.  Mentally she still lived in Russia.
Unfamiliar with the language and life of the country, she dwelt more
in the past than in the present.  It was at this period that she met
a young man who spoke Russian.  With great joy the acquaintance was
cultivated.  At last a person with whom she could converse, one who
could help her bridge the dullness of the narrow existence.  The
friendship gradually ripened and finally culminated in marriage.
</p>
<p class="calibre12">
Emma Goldman, too, had to walk the sorrowful road of married life;
she, too, had to learn from bitter experience that legal statutes
signify dependence and self-effacement, especially for the woman.
The marriage was no liberation from the Puritan dreariness of
American life; indeed, it was rather aggravated by the loss of
self-ownership.  The characters of the young people differed too
widely.  A separation soon followed, and Emma Goldman went to New
Haven, Conn.  There she found employment in a factory, and her
husband disappeared from her horizon.  Two decades later she was
fated to be unexpectedly reminded of him by the Federal authorities.
</p>
<p class="calibre12">
The revolutionists who were active in the Russian movement of the
80's were but little familiar with the social ideas then agitating
Western Europe and America.  Their sole activity consisted in
educating the people, their final goal the destruction of the
autocracy.  Socialism and Anarchism were terms hardly known even by
name.  Emma Goldman, too, was entirely unfamiliar with the
significance of those ideals.
</p>
<p class="calibre12">
She arrived in America, as four years previously in Russia, at a
period of great social and political unrest.  The working people were
in revolt against the terrible labor conditions; the eight-hour
movement of the Knights of Labor was at its height, and throughout
the country echoed the din of sanguine strife between strikers and
police.  The struggle culminated in the great strike against the
Harvester Company of Chicago, the massacre of the strikers, and the
judicial murder of the labor leaders, which followed upon the
historic Haymarket bomb explosion.  The Anarchists stood the martyr
test of blood baptism.  The apologists of capitalism vainly seek to
justify the killing of Parsons, Spies, Lingg, Fischer, and Engel.
Since the publication of Governor Altgeld's reason for his liberation
of the three incarcerated Haymarket Anarchists, no doubt is left that
a fivefold legal murder had been committed in Chicago, in 1887.
</p>
<p class="calibre12">
Very few have grasped the significance of the Chicago martyrdom;
least of all the ruling classes.  By the destruction of a number of
labor leaders they thought to stem the tide of a world-inspiring
idea.  They failed to consider that from the blood of the martyrs
grows the new seed, and that the frightful injustice will win new
converts to the Cause.
</p>
<p class="calibre12">
The two most prominent representatives of the Anarchist idea in
America, Voltairine de Cleyre and Emma Goldman—the one a native
American, the other a Russian—have been converted, like numerous
others, to the ideas of Anarchism by the judicial murder.  Two women
who had not known each other before, and who had received a widely
different education, were through that murder united in one idea.
</p>
<p class="calibre12">
Like most working men and women of America, Emma Goldman followed the
Chicago trial with great anxiety and excitement.  She, too, could not
believe that the leaders of the proletariat would be killed.  The
11th of November, 1887, taught her differently.  She realized that no
mercy could be expected from the ruling class, that between the
Tsarism of Russia and the plutocracy of America there was no
difference save in name.  Her whole being rebelled against the crime,
and she vowed to herself a solemn vow to join the ranks of the
revolutionary proletariat and to devote all her energy and strength
to their emancipation from wage slavery.  With the glowing enthusiasm
so characteristic of her nature, she now began to familiarize herself
with the literature of Socialism and Anarchism.  She attended public
meetings and became acquainted with socialistically and
anarchistically inclined workingmen.  Johanna Greie, the well-known
German lecturer, was the first Socialist speaker heard by Emma
Goldman.  In New Haven, Conn., where she was employed in a corset
factory, she met Anarchists actively participating in the movement.
Here she read the FREIHEIT, edited by John Most.  The Haymarket
tragedy developed her inherent Anarchist tendencies: the reading of
the FREIHEIT made her a conscious Anarchist.  Subsequently she was to
learn that the idea of Anarchism found its highest expression through
the best intellects of America: theoretically by Josiah Warren,
Stephen Pearl Andrews, Lysander Spooner; philosophically by Emerson,
Thoreau, and Walt Whitman.
</p>
<p class="calibre12">
Made ill by the excessive strain of factory work, Emma Goldman
returned to Rochester where she remained till August, 1889, at which
time she removed to New York, the scene of the most important phase
of her life.  She was now twenty years old.  Features pallid with
suffering, eyes large and full of compassion, greet one in her
pictured likeness of those days.  Her hair is, as customary with
Russian student girls, worn short, giving free play to the strong
forehead.
</p>
<p class="calibre12">
It is the heroic epoch of militant Anarchism.  By leaps and bounds
the movement had grown in every country.  In spite of the most severe
governmental persecution new converts swell the ranks.  The
propaganda is almost exclusively of a secret character.  The
repressive measures of the government drive the disciples of the new
philosophy to conspirative methods.  Thousands of victims fall into
the hands of the authorities and languish in prisons.  But nothing
can stem the rising tide of enthusiasm, of self-sacrifice and
devotion to the Cause.  The efforts of teachers like Peter Kropotkin,
Louise Michel, Elisee Reclus, and others, inspire the devotees with
ever greater energy.
</p>
<p class="calibre12">
Disruption is imminent with the Socialists, who have sacrificed the
idea of liberty and embraced the State and politics.  The struggle is
bitter, the factions irreconcilable.  This struggle is not merely
between Anarchists and Socialists; it also finds its echo within the
Anarchist groups.  Theoretic differences and personal controversies
lead to strife and acrimonious enmities.  The anti-Socialist
legislation of Germany and Austria had driven thousands of Socialists
and Anarchists across the seas to seek refuge in America.  John Most,
having lost his seat in the Reichstag, finally had to flee his native
land, and went to London.  There, having advanced toward Anarchism,
he entirely withdrew from the Social Democratic Party.  Later, coming
to America, he continued the publication of the FREIHEIT in New York,
and developed great activity among the German workingmen.
</p>
<p class="calibre12">
When Emma Goldman arrived in New York in 1889, she experienced little
difficulty in associating herself with active Anarchists.  Anarchist
meetings were an almost daily occurrence.  The first lecturer she
heard on the Anarchist platform was Dr. A. Solotaroff.  Of great
importance to her future development was her acquaintance with John
Most, who exerted a tremendous influence over the younger elements.
His impassioned eloquence, untiring energy, and the persecution he
had endured for the Cause, all combined to enthuse the comrades.  It
was also at this period that she met Alexander Berkman, whose
friendship played an important part throughout her life.  Her talents
as a speaker could not long remain in obscurity.  The fire of
enthusiasm swept her toward the public platform.  Encouraged by her
friends, she began to participate as a German and Yiddish speaker at
Anarchist meetings.  Soon followed a brief tour of agitation taking
her as far as Cleveland.  With the whole strength and earnestness of
her soul she now threw herself into the propaganda of Anarchist
ideas.  The passionate period of her life had begun.  Through
constantly toiling in sweat shops, the fiery young orator was at the
same time very active as an agitator and participated in various
labor struggles, notably in the great cloakmakers' strike, in 1889,
led by Professor Garsyde and Joseph Barondess.
</p>
<p class="calibre12">
A year later Emma Goldman was a delegate to an Anarchist conference
in New York.  She was elected to the Executive Committee, but later
withdrew because of differences of opinion regarding tactical
matters.  The ideas of the German-speaking Anarchists had at that
time not yet become clarified.  Some still believed in parliamentary
methods, the great majority being adherents of strong centralism.
These differences of opinion in regard to tactics led in 1891 to a
breach with John Most.  Emma Goldman, Alexander Berkman, and other
comrades joined the group AUTONOMY, in which Joseph Peukert, Otto
Rinke, and Claus Timmermann played an active part.  The bitter
controversies which followed this secession terminated only with the
death of Most, in 1906.
</p>
<p class="calibre12">
A great source of inspiration to Emma Goldman proved the Russian
revolutionists who were associated in the group ZNAMYA.  Goldenberg,
Solotaroff, Zametkin, Miller, Cahan, the poet Edelstadt, Ivan von
Schewitsch, husband of Helene von Racowitza and editor of the
VOLKSZEITUNG, and numerous other Russian exiles, some of whom are
still living, were members of this group.  It was also at this time
that Emma Goldman met Robert Reitzel, the German-American Heine, who
exerted a great influence on her development.  Through him she became
acquainted with the best writers of modern literature, and the
friendship thus begun lasted till Reitzel's death, in 1898.
</p>
<p class="calibre12">
The labor movement of America had not been drowned in the Chicago
massacre; the murder of the Anarchists had failed to bring peace to
the profit-greedy capitalist.  The struggle for the eight-hour day
continued.  In 1892 broke out the great strike in Pittsburg.  The
Homestead fight, the defeat of the Pinkertons, the appearance of the
militia, the suppression of the strikers, and the complete triumph of
the reaction are matters of comparatively recent history.  Stirred to
the very depths by the terrible events at the seat of war, Alexander
Berkman resolved to sacrifice his life to the Cause and thus give an
object lesson to the wage slaves of America of active Anarchist
solidarity with labor.  His attack upon Frick, the Gessler of
Pittsburg, failed, and the twenty-two-year-old youth was doomed to a
living death of twenty-two years in the penitentiary.  The
bourgeoisie, which for decades had exalted and eulogized tyrannicide,
now was filled with terrible rage.  The capitalist press organized a
systematic campaign of calumny and misrepresentation against
Anarchists.  The police exerted every effort to involve Emma Goldman
in the act of Alexander Berkman.  The feared agitator was to be
silenced by all means.  It was only due to the circumstance of her
presence in New York that she escaped the clutches of the law.  It
was a similar circumstance which, nine years later, during the
McKinley incident, was instrumental in preserving her liberty.  It is
almost incredible with what amount of stupidity, baseness, and
vileness the journalists of the period sought to overwhelm the
Anarchist.  One must peruse the newspaper files to realize the
enormity of incrimination and slander.  It would be difficult to
portray the agony of soul Emma Goldman experienced in those days.
The persecutions of the capitalist press were to be borne by an
Anarchist with comparative equanimity; but the attacks from one's own
ranks were far more painful and unbearable.  The act of Berkman was
severely criticized by Most and some of his followers among the
German and Jewish Anarchists.  Bitter accusations and recriminations
at public meetings and private gatherings followed.  Persecuted on
all sides, both because she championed Berkman and his act, and on
account of her revolutionary activity, Emma Goldman was harassed even
to the extent of inability to secure shelter.  Too proud to seek
safety in the denial of her identity, she chose to pass the nights in
the public parks rather than expose her friends to danger or vexation
by her visits.  The already bitter cup was filled to overflowing by
the attempted suicide of a young comrade who had shared living
quarters with Emma Goldman, Alexander Berkman, and a mutual artist
friend.
</p>
<p class="calibre12">
Many changes have since taken place.  Alexander Berkman has survived
the Pennsylvania Inferno, and is back again in the ranks of the
militant Anarchists, his spirit unbroken, his soul full of enthusiasm
for the ideals of his youth.  The artist comrade is now among the
well-known illustrators of New York.  The suicide candidate left
America shortly after his unfortunate attempt to die, and was
subsequently arrested and condemned to eight years of hard labor for
smuggling Anarchist literature into Germany.  He, too, has withstood
the terrors of prison life, and has returned to the revolutionary
movement, since earning the well deserved reputation of a talented
writer in Germany.
</p>
<p class="calibre12">
To avoid indefinite camping in the parks Emma Goldman finally was
forced to move into a house on Third Street, occupied exclusively by
prostitutes.  There, among the outcasts of our good Christian
society, she could at least rent a bit of a room, and find rest and
work at her sewing machine.  The women of the street showed more
refinement of feeling and sincere sympathy than the priests of the
Church.  But human endurance had been exhausted by overmuch suffering
and privation.  There was a complete physical breakdown, and the
renowned agitator was removed to the "Bohemian Republic"—a large
tenement house which derived its euphonious appellation from the fact
that its occupants were mostly Bohemian Anarchists.  Here Emma
Goldman found friends ready to aid her.  Justus Schwab, one of the
finest representatives of the German revolutionary period of that
time, and Dr. Solotaroff were indefatigable in the care of the
patient.  Here, too, she met Edward Brady, the new friendship
subsequently ripening into close intimacy.  Brady had been an active
participant in the revolutionary movement of Austria and had, at the
time of his acquaintance with Emma Goldman, lately been released from
an Austrian prison after an incarceration of ten years.
</p>
<p class="calibre12">
Physicians diagnosed the illness as consumption, and the patient was
advised to leave New York.  She went to Rochester, in the hope that
the home circle would help restore her to health.  Her parents had
several years previously emigrated to America, settling in that city.
Among the leading traits of the Jewish race is the strong attachment
between the members of the family, and, especially, between parents
and children.  Though her conservative parents could not sympathize
with the idealist aspirations of Emma Goldman and did not approve of
her mode of life, they now received their sick daughter with open
arms.  The rest and care enjoyed in the parental home, and the
cheering presence of the beloved sister Helene, proved so beneficial
that within a short time she was sufficiently restored to resume her
energetic activity.
</p>
<p class="calibre12">
There is no rest in the life of Emma Goldman.  Ceaseless effort and
continuous striving toward the conceived goal are the essentials of
her nature.  Too much precious time had already been wasted.  It was
imperative to resume her labors immediately.  The country was in the
throes of a crisis, and thousands of unemployed crowded the streets
of the large industrial centers.  Cold and hungry they tramped
through the land in the vain search for work and bread.  The
Anarchists developed a strenuous propaganda among the unemployed and
the strikers.  A monster demonstration of striking cloakmakers and of
the unemployed took place at Union Square, New York.  Emma Goldman
was one of the invited speakers.  She delivered an impassioned
speech, picturing in fiery words the misery of the wage slave's life,
and quoted the famous maxim of Cardinal Manning: "Necessity knows no
law, and the starving man has a natural right to a share of his
neighbor's bread."  She concluded her exhortation with the words:
"Ask for work.  If they do not give you work, ask for bread.  If they
do not give you work or bread, then take bread."
</p>
<p class="calibre12">
The following day she left for Philadelphia, where she was to address
a public meeting.  The capitalist press again raised the alarm.  If
Socialists and Anarchists were to be permitted to continue agitating,
there was imminent danger that the workingmen would soon learn to
understand the manner in which they are robbed of the joy and
happiness of life.  Such a possibility was to be prevented at all
cost.  The Chief of Police of New York, Byrnes, procured a court
order for the arrest of Emma Goldman.  She was detained by the
Philadelphia authorities and incarcerated for several days in the
Moyamensing prison, awaiting the extradition papers which Byrnes
intrusted to Detective Jacobs.  This man Jacobs (whom Emma Goldman
again met several years later under very unpleasant circumstances)
proposed to her, while she was returning a prisoner to New York, to
betray the cause of labor.  In the name of his superior, Chief
Byrnes, he offered lucrative reward.  How stupid men sometimes are!
What poverty of psychologic observation to imagine the possibility of
betrayal on the part of a young Russian idealist, who had willingly
sacrificed all personal considerations to help in labor's
emancipation.
</p>
<p class="calibre12">
In October, 1893, Emma Goldman was tried in the criminal courts of
New York on the charge of inciting to riot.  The "intelligent" jury
ignored the testimony of the twelve witnesses for the defense in
favor of the evidence given by one single man—Detective Jacobs.  She
was found guilty and sentenced to serve one year in the penitentiary
at Blackwell's Island.  Since the foundation of the Republic she was
the first woman—Mrs. Surratt excepted—to be imprisoned for a
political offense.  Respectable society had long before stamped upon
her the Scarlet Letter.
</p>
<p class="calibre12">
Emma Goldman passed her time in the penitentiary in the capacity of
nurse in the prison hospital.  Here she found opportunity to shed
some rays of kindness into the dark lives of the unfortunates whose
sisters of the street did not disdain two years previously to share
with her the same house.  She also found in prison opportunity to
study English and its literature, and to familiarize herself with the
great American writers.  In Bret Harte, Mark Twain, Walt Whitman,
Thoreau, and Emerson she found great treasures.
</p>
<p class="calibre12">
She left Blackwell's Island in the month of August, 1894, a woman of
twenty-five, developed and matured, and intellectually transformed.
Back into the arena, richer in experience, purified by suffering.
She did not feel herself deserted and alone any more.  Many hands
were stretched out to welcome her.  There were at the time numerous
intellectual oases in New York.  The saloon of Justus Schwab, at
Number Fifty, First Street, was the center where gathered Anarchists,
litterateurs, and bohemians.  Among others she also met at this time
a number of American Anarchists, and formed the friendship of
Voltairine de Cleyre, Wm. C. Owen, Miss Van Etton, and Dyer D. Lum,
former editor of the ALARM and executor of the last wishes of the
Chicago martyrs.  In John Swinton, the noble old fighter for liberty,
she found one of her staunchest friends.  Other intellectual centers
there were: SOLIDARITY, published by John Edelman; LIBERTY, by the
Individualist Anarchist, Benjamin R. Tucker; the REBEL, by Harry
Kelly; DER STURMVOGEL, a German Anarchist publication, edited by
Claus Timmermann; DER ARME TEUFEL, whose presiding genius was the
inimitable Robert Reitzel.  Through Arthur Brisbane, now chief
lieutenant of William Randolph Hearst, she became acquainted with the
writings of Fourier.  Brisbane then was not yet submerged in the
swamp of political corruption.  He sent Emma Goldman an amiable
letter to Blackwell's Island, together with the biography of his
father, the enthusiastic American disciple of Fourier.
</p>
<p class="calibre12">
Emma Goldman became, upon her release from the penitentiary, a factor
in the public life of New York.  She was appreciated in radical ranks
for her devotion, her idealism, and earnestness.  Various persons
sought her friendship, and some tried to persuade her to aid in the
furtherance of their special side issues.  Thus Rev. Parkhurst,
during the Lexow investigation, did his utmost to induce her to join
the Vigilance Committee in order to fight Tammany Hall.  Maria
Louise, the moving spirit of a social center, acted as Parkhurst's
go-between.  It is hardly necessary to mention what reply the latter
received from Emma Goldman.  Incidentally, Maria Louise subsequently
became a Mahatma.  During the free silver campaign, ex-Burgess
McLuckie, one of the most genuine personalities in the Homestead
strike, visited New York in an endeavor to enthuse the local radicals
for free silver.  He also attempted to interest Emma Goldman, but
with no greater success than Mahatma Maria Louise of Parkhurst-Lexow
fame.
</p>
<p class="calibre12">
In 1894 the struggle of the Anarchists in France reached its highest
expression.  The white terror on the part of the Republican upstarts
was answered by the red terror of our French comrades.  With feverish
anxiety the Anarchists throughout the world followed this social
struggle.  Propaganda by deed found its reverberating echo in almost
all countries.  In order to better familiarize herself with
conditions in the old world, Emma Goldman left for Europe, in the
year 1895.  After a lecture tour in England and Scotland, she went to
Vienna where she entered the ALLGEMEINE KRANKENHAUS to prepare
herself as midwife and nurse, and where at the same time she studied
social conditions.  She also found opportunity to acquaint herself
with the newest literature of Europe: Hauptmann, Nietzsche, Ibsen,
Zola, Thomas Hardy, and other artist rebels were read with great
enthusiasm.
</p>
<p class="calibre12">
In the autumn of 1896 she returned to New York by way of Zurich and
Paris.  The project of Alexander Berkman's liberation was on hand.
The barbaric sentence of twenty-two years had roused tremendous
indignation among the radical elements.  It was known that the Pardon
Board of Pennsylvania would look to Carnegie and Frick for advice in
the case of Alexander Berkman.  It was therefore suggested that these
Sultans of Pennsylvania be approached—not with a view of obtaining
their grace, but with the request that they do not attempt to
influence the Board.  Ernest Crosby offered to see Carnegie, on
condition that Alexander Berkman repudiate his act.  That, however,
was absolutely out of the question.  He would never be guilty of such
forswearing of his own personality and self-respect.  These efforts
led to friendly relations between Emma Goldman and the circle of
Ernest Crosby, Bolton Hall, and Leonard Abbott.  In the year 1897 she
undertook her first great lecture tour, which extended as far as
California.  This tour popularized her name as the representative of
the oppressed, her eloquence ringing from coast to coast.  In
California Emma Goldman became friendly with the members of the Isaak
family, and learned to appreciate their efforts for the Cause.  Under
tremendous obstacles the Isaaks first published the FIREBRAND and,
upon its suppression by the Postal Department, the FREE SOCIETY.  It
was also during this tour that Emma Goldman met that grand old rebel
of sexual freedom, Moses Harman.
</p>
<p class="calibre12">
During the Spanish-American war the spirit of chauvinism was at its
highest tide.  To check this dangerous situation, and at the same
time collect funds for the revolutionary Cubans, Emma Goldman became
affiliated with the Latin comrades, among others with Gori, Esteve,
Palaviccini, Merlino, Petruccini, and Ferrara.  In the year 1899
followed another protracted tour of agitation, terminating on the
Pacific Coast.  Repeated arrests and accusations, though without
ultimate bad results, marked every propaganda tour.
</p>
<p class="calibre12">
In November of the same year the untiring agitator went on a second
lecture tour to England and Scotland, closing her journey with the
first International Anarchist Congress at Paris.  It was at the time of
the Boer war, and again jingoism was at its height, as two years
previously it had celebrated its orgies during the Spanish-American
war.  Various meetings, both in England and Scotland, were disturbed
and broken up by patriotic mobs.  Emma Goldman found on this occasion
the opportunity of again meeting various English comrades and
interesting personalities like Tom Mann and the sisters Rossetti, the
gifted daughters of Dante Gabriel Rossetti, then publishers of the
Anarchist review, the TORCH.  One of her life-long hopes found here
its fulfillment: she came in close and friendly touch with Peter
Kropotkin, Enrico Malatesta, Nicholas Tchaikovsky, W. Tcherkessov,
and Louise Michel.  Old warriors in the cause of humanity, whose
deeds have enthused thousands of followers throughout the world, and
whose life and work have inspired other thousands with noble idealism
and self-sacrifice.  Old warriors they, yet ever young with the
courage of earlier days, unbroken in spirit and filled with the firm
hope of the final triumph of Anarchy.
</p>
<p class="calibre12">
The chasm in the revolutionary labor movement, which resulted from
the disruption of the INTERNATIONALE, could not be bridged any more.
Two social philosophies were engaged in bitter combat.  The
International Congress in 1889, at Paris; in 1892, at Zurich, and in
1896, at London, produced irreconcilable differences.  The majority
of Social Democrats, forswearing their libertarian past and becoming
politicians, succeeded in excluding the revolutionary and Anarchist
delegates.  The latter decided thenceforth to hold separate
congresses.  Their first congress was to take place in 1900, at
Paris.  The Socialist renegade, Millerand, who had climbed into the
Ministry of the Interior, here played a Judas role.  The congress of
the revolutionists was suppressed, and the delegates dispersed two
days prior to their scheduled opening.  But Millerand had no
objections against the Social Democratic Congress, which was
afterwards opened with all the trumpets of the advertiser's art.
</p>
<p class="calibre12">
However, the renegade did not accomplish his object.  A number of
delegates succeeded in holding a secret conference in the house of a
comrade outside of Paris, where various points of theory and tactics
were discussed.  Emma Goldman took considerable part in these
proceedings, and on that occasion came in contact with numerous
representatives of the Anarchist movement of Europe.
</p>
<p class="calibre12">
Owing to the suppression of the congress, the delegates were in
danger of being expelled from France.  At this time also came the bad
news from America regarding another unsuccessful attempt to liberate
Alexander Berkman, proving a great shock to Emma Goldman.  In
November, 1900, she returned to America to devote herself to her
profession of nurse, at the same time taking an active part in the
American propaganda.  Among other activities she organized monster
meetings of protest against the terrible outrages of the Spanish
government, perpetrated upon the political prisoners tortured in
Montjuich.
</p>
<p class="calibre12">
In her vocation as nurse Emma Goldman enjoyed many opportunities of
meeting the most unusual and peculiar characters.  Few would have
identified the "notorious Anarchist" in the small blonde woman,
simply attired in the uniform of a nurse.  Soon after her return from
Europe she became acquainted with a patient by the name of Mrs.
Stander, a morphine fiend, suffering excruciating agonies.  She
required careful attention to enable her to supervise a very
important business she conducted,—that of Mrs. Warren.  In Third
Street, near Third Avenue, was situated her private residence, and
near it, connected by a separate entrance, was her place of business.
One evening, the nurse, upon entering the room of her patient,
suddenly came face to face with a male visitor, bull-necked and of
brutal appearance.  The man was no other than Mr. Jacobs, the
detective who seven years previously had brought Emma Goldman a
prisoner from Philadelphia and who had attempted to persuade her, on
their way to New York, to betray the cause of the workingmen.  It
would be difficult to describe the expression of bewilderment on the
countenance of the man as he so unexpectedly faced Emma Goldman, the
nurse of his mistress.  The brute was suddenly transformed into a
gentleman, exerting himself to excuse his shameful behavior on the
previous occasion.  Jacobs was the "protector" of Mrs. Stander, and
go-between for the house and the police.  Several years later, as one
of the detective staff of District Attorney Jerome, he committed
perjury, was convicted, and sent to Sing Sing for a year.  He is now
probably employed by some private detective agency, a desirable
pillar of respectable society.
</p>
<p class="calibre12">
In 1901 Peter Kropotkin was invited by the Lowell Institute of
Massachusetts to deliver a series of lectures on Russian literature.
It was his second American tour, and naturally the comrades were
anxious to use his presence for the benefit of the movement.  Emma
Goldman entered into correspondence with Kropotkin and succeeded in
securing his consent to arrange for him a series of lectures.  She
also devoted her energies to organizing the tours of other well known
Anarchists, principally those of Charles W. Mowbray and John Turner.
Similarly she always took part in all the activities of the movement,
ever ready to give her time, ability, and energy to the Cause.
</p>
<p class="calibre12">
On the sixth of September, 1901, President McKinley was shot by Leon
Czolgosz at Buffalo.  Immediately an unprecedented campaign of
persecution was set in motion against Emma Goldman as the best known
Anarchist in the country.  Although there was absolutely no
foundation for the accusation, she, together with other prominent
Anarchists, was arrested in Chicago, kept in confinement for several
weeks, and subjected to severest cross-examination.  Never before in
the history of the country had such a terrible man-hunt taken place
against a person in public life.  But the efforts of police and press
to connect Emma Goldman with Czolgosz proved futile.  Yet the episode
left her wounded to the heart.  The physical suffering, the
humiliation and brutality at the hands of the police she could bear.
The depression of soul was far worse.  She was overwhelmed by
realization of the stupidity, lack of understanding, and vileness
which characterized the events of those terrible days.  The attitude
of misunderstanding on the part of the majority of her own comrades
toward Czolgosz almost drove her to desperation.  Stirred to the very
inmost of her soul, she published an article on Czolgosz in which she
tried to explain the deed in its social and individual aspects.  As
once before, after Berkman's act, she now also was unable to find
quarters; like a veritable wild animal she was driven from place to
place.  This terrible persecution and, especially, the attitude of
her comrades made it impossible for her to continue propaganda.  The
soreness of body and soul had first to heal.  During 1901-1903 she
did not resume the platform.  As "Miss Smith" she lived a quiet life,
practicing her profession and devoting her leisure to the study of
literature and, particularly, to the modern drama, which she
considers one of the greatest disseminators of radical ideas and
enlightened feeling.
</p>
<p class="calibre12">
Yet one thing the persecution of Emma Goldman accomplished.  Her name
was brought before the public with greater frequency and emphasis
than ever before, the malicious harassing of the much maligned
agitator arousing strong sympathy in many circles.  Persons in
various walks of life began to get interested in her struggle and her
ideas.  A better understanding and appreciation were now beginning to
manifest themselves.
</p>
<p class="calibre12">
The arrival in America of the English Anarchist, John Turner, induced
Emma Goldman to leave her retirement.  Again she threw herself into
her public activities, organizing an energetic movement for the
defense of Turner, whom the Immigration authorities condemned to
deportation on account of the Anarchist exclusion law, passed after
the death of McKinley.
</p>
<p class="calibre12">
When Paul Orleneff and Mme. Nazimova arrived in New York to acquaint
the American public with Russian dramatic art, Emma Goldman became
the manager of the undertaking.  By much patience and perseverance
she succeeded in raising the necessary funds to introduce the Russian
artists to the theater-goers of New York and Chicago.  Though
financially not a success, the venture proved of great artistic
value.  As manager of the Russian theater Emma Goldman enjoyed some
unique experiences.  M. Orleneff could converse only in Russian, and
"Miss Smith" was forced to act as his interpreter at various polite
functions.  Most of the aristocratic ladies of Fifth Avenue had not
the least inkling that the amiable manager who so entertainingly
discussed philosophy, drama, and literature at their five o'clock
teas, was the "notorious" Emma Goldman.  If the latter should some
day write her autobiography, she will no doubt have many interesting
anecdotes to relate in connection with these experiences.
</p>
<p class="calibre12">
The weekly Anarchist publication, FREE SOCIETY, issued by the Isaak
family, was forced to suspend in consequence of the nation-wide fury
that swept the country after the death of McKinley.  To fill out the
gap Emma Goldman, in co-operation with Max Baginski and other
comrades, decided to publish a monthly magazine devoted to the
furtherance of Anarchist ideas in life and literature.  The first
issue of MOTHER EARTH appeared in the month of March, 1906, the
initial expenses of the periodical partly covered by the proceeds of
a theater benefit given by Orleneff, Mme. Nazimova, and their
company, in favor of the Anarchist magazine.  Under tremendous
difficulties and obstacles the tireless propagandist has succeeded in
continuing MOTHER EARTH uninterruptedly since 1906—an achievement
rarely equalled in the annals of radical publications.
</p>
<p class="calibre12">
In May, 1906, Alexander Berkman at last left the hell of
Pennsylvania, where he had passed the best fourteen years of his
life.  No one had believed in the possibility of his survival.  His
liberation terminated a nightmare of fourteen years for Emma Goldman,
and an important chapter of her career was thus concluded.
</p>
<p class="calibre12">
Nowhere had the birth of the Russian revolution aroused such vital
and active response as among the Russians living in America.  The
heroes of the revolutionary movement in Russia, Tchaikovsky, Mme.
Breshkovskaia, Gershuni, and others visited these shores to waken the
sympathies of the American people toward the struggle for liberty,
and to collect aid for its continuance and support.  The success of
these efforts was to a considerable extent due to the exertions,
eloquence, and the talent for organization on the part of Emma
Goldman.  This opportunity enabled her to give valuable services to
the struggle for liberty in her native land.  It is not generally
known that it is the Anarchists who are mainly instrumental in
insuring the success, moral as well as financial, of most of the
radical undertakings.  The Anarchist is indifferent to acknowledged
appreciation; the needs of the Cause absorb his whole interest, and
to these he devotes his energy and abilities.  Yet it may be
mentioned that some otherwise decent folks, though at all times
anxious for Anarchist support and co-operation, are ever willing to
monopolize all the credit for the work done.  During the last several
decades it was chiefly the Anarchists who had organized all the great
revolutionary efforts, and aided in every struggle for liberty.  But
for fear of shocking the respectable mob, who looks upon the
Anarchists as the apostles of Satan, and because of their social
position in bourgeois society, the would-be radicals ignore the
activity of the Anarchists.
</p>
<p class="calibre12">
In 1907 Emma Goldman participated as delegate to the second Anarchist
Congress, at Amsterdam.  She was intensely active in all its
proceedings and supported the organization of the Anarchist
INTERNATIONALE.  Together with the other American delegate, Max
Baginski, she submitted to the congress an exhaustive report of
American conditions, closing with the following characteristic
remarks:
</p>
<p class="calibre12">
"The charge that Anarchism is destructive, rather than constructive,
and that, therefore, Anarchism is opposed to organization, is one of
the many falsehoods spread by our opponents.  They confound our
present social institutions with organization; hence they fail to
understand how we can oppose the former, and yet favor the latter.
The fact, however, is that the two are not identical.
</p>
<p class="calibre12">
"The State is commonly regarded as the highest form of organization.
But is it in reality a true organization?  Is it not rather an
arbitrary institution, cunningly imposed upon the masses?
</p>
<p class="calibre12">
"Industry, too, is called an organization; yet nothing is farther
from the truth.  Industry is the ceaseless piracy of the rich against
the poor.
</p>
<p class="calibre12">
"We are asked to believe that the Army is an organization, but a
close investigation will show that it is nothing else than a cruel
instrument of blind force.
</p>
<p class="calibre12">
"The Public School!  The colleges and other institutions of learning,
are they not models of organization, offering the people fine
opportunities for instruction?  Far from it.  The school, more than
any other institution, is a veritable barrack, where the human mind
is drilled and manipulated into submission to various social and
moral spooks, and thus fitted to continue our system of exploitation
and oppression.
</p>
<p class="calibre12">
"Organization, as WE understand it, however, is a different thing.
It is based, primarily, on freedom.  It is a natural and voluntary
grouping of energies to secure results beneficial to humanity.
</p>
<p class="calibre12">
"It is the harmony of organic growth which produces variety of color
and form, the complete whole we admire in the flower.  Analogously
will the organized activity of free human beings, imbued with the
spirit of solidarity, result in the perfection of social harmony,
which we call Anarchism.  In fact, Anarchism alone makes
non-authoritarian organization of common interests possible, since it
abolishes the existing antagonism between individuals and classes.
</p>
<p class="calibre12">
"Under present conditions the antagonism of economic and social
interests results in relentless war among the social units, and
creates an insurmountable obstacle in the way of a co-operative
commonwealth.
</p>
<p class="calibre12">
"There is a mistaken notion that organization does not foster
individual freedom; that, on the contrary, it means the decay of
individuality.  In reality, however, the true function of
organization is to aid the development and growth of personality.
</p>
<p class="calibre12">
"Just as the animal cells, by mutual co-operation, express their
latent powers in formation of the complete organism, so does the
individual, by co-operative effort with other individuals, attain his
highest form of development.
</p>
<p class="calibre12">
"An organization, in the true sense, cannot result from the
combination of mere nonentities.  It must be composed of
self-conscious, intelligent individualities.  Indeed, the total of
the possibilities and activities of an organization is represented in
the expression of individual energies.
</p>
<p class="calibre12">
"It therefore logically follows that the greater the number of
strong, self-conscious personalities in an organization, the less
danger of stagnation, and the more intense its life element.
</p>
<p class="calibre12">
"Anarchism asserts the possibility of an organization without
discipline, fear, or punishment, and without the pressure of poverty:
a new social organism which will make an end to the terrible struggle
for the means of existence,—the savage struggle which undermines the
finest qualities in man, and ever widens the social abyss.  In short,
Anarchism strives towards a social organization which will establish
well-being for all.
</p>
<p class="calibre12">
"The germ of such an organization can be found in that form of trades
unionism which has done away with centralization, bureaucracy, and
discipline, and which favors independent and direct action on the
part of its members."
</p>
<p class="calibre12">
The very considerable progress of Anarchist ideas in America can best
be gauged by the remarkable success of the three extensive lecture
tours of Emma Goldman since the Amsterdam Congress of 1907.  Each
tour extended over new territory, including localities where
Anarchism had never before received a hearing.  But the most
gratifying aspect of her untiring efforts is the tremendous sale of
Anarchist literature, whose propagandist effect cannot be estimated.
It was during one of these tours that a remarkable incident happened,
strikingly demonstrating the inspiring potentialities of the
Anarchist idea.  In San Francisco, in 1908, Emma Goldman's lecture
attracted a soldier of the United States Army, William Buwalda.  For
daring to attend an Anarchist meeting, the free Republic
court-martialed Buwalda and imprisoned him for one year.  Thanks to
the regenerating power of the new philosophy, the government lost a
soldier, but the cause of liberty gained a man.
</p>
<p class="calibre12">
A propagandist of Emma Goldman's importance is necessarily a sharp
thorn to the reaction.  She is looked upon as a danger to the
continued existence of authoritarian usurpation.  No wonder, then,
that the enemy resorts to any and all means to make her impossible.
A systematic attempt to suppress her activities was organized a year
ago by the united police force of the country.  But like all previous
similar attempts, it failed in a most brilliant manner.  Energetic
protests on the part of the intellectual element of America succeeded
in overthrowing the dastardly conspiracy against free speech.
Another attempt to make Emma Goldman impossible was essayed by the
Federal authorities at Washington.  In order to deprive her of the
rights of citizenship, the government revoked the citizenship papers
of her husband, whom she had married at the youthful age of eighteen,
and whose whereabouts, if he be alive, could not be determined for
the last two decades.  The great government of the glorious United
States did not hesitate to stoop to the most despicable methods to
accomplish that achievement.  But as her citizenship had never proved
of use to Emma Goldman, she can bear the loss with a light heart.
</p>
<p class="calibre12">
There are personalities who possess such a powerful individuality
that by its very force they exert the most potent influence over the
best representatives of their time.  Michael Bakunin was such a
personality.  But for him, Richard Wagner had never written DIE KUNST
UND DIE REVOLUTION.  Emma Goldman is a similar personality.  She is a
strong factor in the socio-political life of America.  By virtue of
her eloquence, energy, and brilliant mentality, she moulds the minds
and hearts of thousands of her auditors.
</p>
<p class="calibre12">
Deep sympathy and compassion for suffering humanity, and an
inexorable honesty toward herself, are the leading traits of Emma
Goldman.  No person, whether friend or foe, shall presume to control
her goal or dictate her mode of life.  She would perish rather than
sacrifice her convictions, or the right of self-ownership of soul and
body.  Respectability could easily forgive the teaching of theoretic
Anarchism; but Emma Goldman does not merely preach the new
philosophy; she also persists in living it,—and that is the one
supreme, unforgivable crime.  Were she, like so many radicals, to
consider her ideal as merely an intellectual ornament; were she to
make concessions to existing society and compromise with old
prejudices,—then even the most radical views could be pardoned in
her.  But that she takes her radicalism seriously; that it has
permeated her blood and marrow to the extent where she not merely
teaches but also practices her convictions—this shocks even the
radical Mrs. Grundy.  Emma Goldman lives her own life; she associates
with publicans—hence the indignation of the Pharisees and Sadducees.
</p>
<p class="calibre12">
It is no mere coincidence that such divergent writers as Pietro Gori
and William Marion Reedy find similar traits in their
characterization of Emma Goldman.  In a contribution to LA QUESTIONE
SOCIALE, Pietro Gori calls her a "moral power, a woman who, with the
vision of a sibyl, prophesies the coming of a new kingdom for the
oppressed; a woman who, with logic and deep earnestness, analyses the
ills of society, and portrays, with artist touch, the coming dawn of
humanity, founded on equality, brotherhood, and liberty."
</p>
<p class="calibre12">
William Reedy sees in Emma Goldman the "daughter of the dream, her
gospel a vision which is the vision of every truly great-souled man
and woman who has ever lived."
</p>
<p class="calibre12">
Cowards who fear the consequences of their deeds have coined the word
of philosophic Anarchism.  Emma Goldman is too sincere, too defiant,
to seek safety behind such paltry pleas.  She is an Anarchist, pure
and simple.  She represents the idea of Anarchism as framed by Josiah
Warrn, Proudhon, Bakunin, Kropotkin, Tolstoy.  Yet she also
understands the psychologic causes which induce a Caserio, a
Vaillant, a Bresci, a Berkman, or a Czolgosz to commit deeds of
violence.  To the soldier in the social struggle it is a point of
honor to come in conflict with the powers of darkness and tyranny,
and Emma Goldman is proud to count among her best friends and
comrades men and women who bear the wounds and scars received in
battle.
</p>
<p class="calibre12">
In the words of Voltairine de Cleyre, characterizing Emma Goldman
after the latter's imprisonment in 1893: The spirit that animates
Emma Goldman is the only one which will emancipate the slave from his
slavery, the tyrant from his tyranny—the spirit which is willing to
dare and suffer.
</p>
<p class="noindent">
HIPPOLYTE HAVEL.
<br class="calibre5"/>
New York, December, 1910.
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2333a7af